import { RECENT_OPENS_TITLES } from "@loot-os/api-contract";
import type { TopHitsContent } from "@loot-os/design-system/templates/boxes/boxesContent";
import { useBestOpens } from "../../shared/bestOpens.js";

/** The boxes page's "Top hits": the shopper's best recent opens, as the home page shows them. */
export function useTopHitsContent(): TopHitsContent {
  return { title: RECENT_OPENS_TITLES.catalog, opens: useBestOpens() };
}
